var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuList',{staticClass:"app-left",attrs:{"collapsed":_vm.collapsed,"menu-data":_vm.subMenuList,"collapsible":true,"isMobile":false}})}
var staticRenderFns = []

export { render, staticRenderFns }